import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, InputNumber, Radio, TimePicker, Modal, Tag, Tooltip, Empty
} from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';
import { stringContaint } from "../../../utils/common"
import {
    getAppRestriction, deleteAppRestriction, addAppRestriction, deleteAppRestrictionAlone,
    getAndroidAppRestriction, deleteAndroidAppRestriction, addAndroidAppRestriction, deleteAndroidAppRestrictionAlone
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"
import { time } from "console";
import dayjs from 'dayjs';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import {
    getAppType,getAndroidAppType
} from "../../../axios/api.app"
import tags from "@src/home/account/tags";
import { v4 as uuidv4 } from "uuid";

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateAppRestriction = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [tableLoading, setTableLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showTable, setShowTable] = useState<number>(0);
    const [selectKey, setSelectKey] = useState<string>("everyDay");
    const [selectWeek, setSelectWeek] = useState<number>(0);
    const [dayList, setDayList] = useState<any[]>([]);
    const [resData, setResData] = useState<any[]>([]);
    const [resDatabak, setResDatabak] = useState<any[]>([]);
    const [appTypes, setAppTypes] = useState<any[]>([]);
    const [selectType, setSelectType] = useState<number[]>([]);
    const [selectId, setSelectId] = useState<string>("");
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo();
        getBasic();
        return () => { localStorage.removeItem('appLimits') }
    }, [])
    const getBasic = () => {
        if (platform == "Android") {
            getAndroidAppType().then(res => {
                var types:any[]=[];
                setAppTypes([]);
                res.forEach((ty:any) => {
                    types.push({id:ty.id,chineseName:ty.typeName})
                });
                setAppTypes(types)
            })
        }else{
            getAppType().then(res => {
                setAppTypes(res)
            })
        }
    
    }
    const setModelInfo = (res: any) => {
        console.log("setModelInfo", res)
        setIsEdit(true)
        setSelectId(res.id)
        setSelectType(res.categories);
        setSelectKey(res.isCustomized ? "custom" : "everyDay")
        dayList.pop();
        var dl: any[] = []
        res.executionRules?.forEach((item: any) => {
            var times: any[] = [];
            item.durations?.forEach((itm: any) => {
                var starArr = itm.startTime.split(":");
                var endArr = itm.endTime.split(":");
                var startTime = dayjs().hour(parseInt(starArr[0])).minute(parseInt(starArr[1]));
                var endTime = dayjs().hour(parseInt(endArr[0])).minute(parseInt(endArr[1]));
                times.push([startTime, endTime])
            });
            dl.push({
                times: times,
                worshipDay: item.worshipDay
            });
        })
        setDayList([...dl]);
        setShowModal(true);
    }
    const getDataInfo = (datas: any = []) => {
        var localDataString = localStorage.getItem('appLimits');
        var localData = localDataString ? JSON.parse(localDataString) : [];

        if (platform == "Android") {
            getAndroidAppRestriction(templateId).then((res) => {
                setResDatabak(res);
                if (datas.length > 0) {
                    res = localData;
                } 
                // else {
                //     var resID = res.map((item: any) => item.id);
                //     var localDataID = localData.map((item: any) => item.id);
                //     resID.forEach((id: string, index: string) => {
                //         if (!localDataID.includes(id)) {
                //             localData.push(res[index]);
                //         }
                //     });
                //     localStorage.setItem('appLimits', JSON.stringify(localData));
                //     res = localData;
                // }
                // setLoading(false);
                if (res && res.length != 0) {
                    setResData(res);
                    setShowTable(2);
                } else {
                    setShowTable(1);
                }
            })
        } else {
            getAppRestriction(templateId).then((res) => {
                setResDatabak(res);
                if (datas.length > 0) {
                    res = localData;
                } 
                // else {
                //     var resID = res.map((item: any) => item.id);
                //     var localDataID = localData.map((item: any) => item.id);
                //     resID.forEach((id: string, index: string) => {
                //         if (!localDataID.includes(id)) {
                //             localData.push(res[index]);
                //         }
                //     });
                //     localStorage.setItem('appLimits', JSON.stringify(localData));
                //     res = localData;
                // }

                // setLoading(false);
                if (res && res.length != 0) {
                    setResData(res);
                    setShowTable(2);
                } else {
                    setShowTable(1);
                }
            })
        }
    }
    const addTimeClick = () => {
        var item = getCurret();
        if (item) {
            var startTime = dayjs().hour(0).minute(0);
            if (item.times.length != 0) {
                startTime = item.times[item.times.length - 1][1]
            }
            var endTime;
            if (startTime.hour() == 23) {
                endTime = dayjs().hour(23).minute(59);
            } else {
                endTime = dayjs().hour(startTime.hour() + 1).minute(0);
            }
            item.times.push([startTime, endTime])
            setDayList([...dayList])
        } else {
            var startTime = dayjs().hour(0).minute(0);
            var endTimee = dayjs().hour(1).minute(0);
            item = {
                times: [],
                worshipDay: selectWeek
            };
            item.times.push([startTime, endTimee])
            dayList.push(item)
            setDayList([...dayList])
        }
    }
    const timeChange = (value: any, index: number) => {
        var currentDay = getCurret();
        currentDay.times[index] = value
        if (currentDay.times.length != (index + 1)) {
            if (currentDay.times[index + 1][1].hour() <= value[1].hour() && currentDay.times[index + 1][1].minute() < value[1].minute()) {
                currentDay.times.splice(index + 1, currentDay.times.length - index - 1)
            }
        }
        setDayList([...dayList])
    }
    const deleteTime = (index: number) => {
        var item = getCurret();
        item.times.splice(index, 1)
        setDayList([...dayList])
    }

    const addTemplateClick = (datas: any = []) => {
        // var res: any = {};
        // setLoading(true);
        // res.categories = selectType;
        // res.executionRules = [];
        // res.IsCustomized = selectKey == "custom"
        // res.id = selectId;
        // var i = 0;
        // for (i; i < dayList.length; i++) {
        //     var item = dayList[i];
        //     if (!res.IsCustomized && item.worshipDay != 0) {
        //         continue;
        //     }
        //     if (item.times.length > 0) {
        //         var durations: any[] = [];
        //         item.times.forEach((time: any) => {
        //             durations.push({
        //                 startTime: time[0].format('HH:mm'),
        //                 endTime: time[1].format('HH:mm')
        //             })
        //         });
        //         res.executionRules.push({
        //             worshipDay: item.worshipDay,
        //             durations: durations
        //         })
        //     }
        // }
        
        if (datas.length > 0) {
            if (platform == "Android") {
                deleteAndroidAppRestriction(templateId).then(() => {
                    addAndroidAppRestriction(templateId, datas).then(() => {
                        updateTemplate();
                        notification.success({ message: t("成功") });
                        localStorage.removeItem('appLimits')
                        getDataInfo();
                        setLoading(false);
                        setShowModal(false);
                        setIsEdit(false);
                    }, () => {
                        notification.error({ message: t("失败") })
                    })
                })

            } else {
                deleteAppRestriction(templateId).then(() => {
                    addAppRestriction(templateId, datas).then(() => {
                        updateTemplate();
                        notification.success({ message: t("成功") });
                        localStorage.removeItem('appLimits');
                        getDataInfo();
                        setLoading(false);
                        setShowModal(false);
                        setIsEdit(false);
                    }, () => {
                        notification.error({ message: t("失败") })
                    })
                })
            }
        } else {
            notification.warning({ message: t("请添加限制后再保存") });
        }
        
        // if (res.categories.length > 0 && res.executionRules.length > 0) {
        //     if (platform == "Android") {
        //         addAndroidAppRestriction(templateId, [res]).then(c => {
        //             notification.success({ message: "成功" });
        //             getDataInfo();
        //             setLoading(false);
        //             setShowModal(false);
        //             setIsEdit(false);
        //         }, () => {
        //             notification.error({ message: "失败" })
        //         })
        //     } else {
        //         addAppRestriction(templateId, [res]).then(c => {
        //             notification.success({ message: "成功" });
        //             getDataInfo();
        //             setLoading(false);
        //             setShowModal(false);
        //             setIsEdit(false);
        //         }, () => {
        //             notification.error({ message: "失败" })
        //         })
        //     }
        // } else {
        //     notification.warning({message: "所有字段不能为空!"});
        //     getDataInfo();
        //     setLoading(false);
        //     setShowModal(false);
        // }
        
    }
    const deleteTemplateClick = () => {
        localStorage.removeItem('appLimits');
        setResData([]);
        if (platform == "Android") {
            deleteAndroidAppRestriction(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        }else{
            deleteAppRestriction(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        }

    }

    function appTypeChange(value: any) {
        setSelectType(value);
    }
    function getCurret() {
        var item = dayList?.find(c => {
            return c.worshipDay == selectWeek;
        })
        return item;
    }
    function selectTypeChange(key: string) {
        setSelectKey(key);
        if (key == "everyDay") {
            for (var i = 0; i < dayList.length; i++) {
                dayList[i] = Object.assign({}, dayList[selectWeek])
            }
            setDayList([...dayList])
        }
    }
    function getAppName(id: number) {
        var re = (appTypes?.find(c => {
            return c.id == id
        }));
        return re?.chineseName ?? "";
    }
    function deleteAppRestrictionAloneClick(id: string) {
        var localDataString = localStorage.getItem('appLimits');
        var localData = localDataString ? JSON.parse(localDataString) : [];
        if (localData.length > 0) {
            var filterData = localData.filter((data: any) => { return data.id !== id });
            if (filterData.length !== localData.length) {
                localStorage.setItem('appLimits', JSON.stringify(filterData));
                getDataInfo()
                return
                // if (filterData.length > 0) {
                //     getDataInfo(filterData);
                // } else {
                //     setResData(filterData);
                // }
            }
        }
        // setLoading(true)
        setResData([]);
        if (platform == "Android") {
            deleteAndroidAppRestrictionAlone(id).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        } else {
            deleteAppRestrictionAlone(id).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        }
    }
    function getTimeShow(obj: any, isCustomized: any) {
        return (
            <>
                {obj.map((item: any, index: number) => (
                    <p key={index}>
                        <span>{getWeekName(item.worshipDay, isCustomized)}</span>
                        {item.durations.map((itm: any, inx: number) => (
                            <span key={inx} style={{ marginLeft: 6 }}> {itm.startTime.substring(0, 5) + "~" + itm.endTime.substring(0, 5)}</span>
                        ))}
                    </p>
                ))}
            </>)

    }
    function getWeekName(no: number, isCustomized: any) {
        if (!isCustomized) {
            return t("每天")
        }
        var name = ""
        switch (no) {
            case 0:
                name = t("星期天");
                break;
            case 1:
                name = t("星期一");
                break;
            case 2:
                name = t("星期二");
                break;
            case 3:
                name = t("星期三");
                break;
            case 4:
                name = t("星期四");
                break;
            case 5:
                name = t("星期五");
                break;
            case 6:
                name = t("星期六");
                break;
        }
        return name;
    }
    function getWeedTimeShow() {
        var item = getCurret();
        if (item) {
            return (item?.times?.map((item: any, index: number) => (
                <Col key={index} span={24}>
                    <Row>
                        <Col span={18}>
                            <TimePicker.RangePicker value={item}
                                format={"HH:mm"}
                                minuteStep={1}
                                hideDisabledOptions={true}
                                onChange={(e) => { timeChange(e, index) }} 
                            />
                        </Col>
                        <Col span={5} offset={1}>
                            <Button type="primary" danger shape="circle" icon={<DeleteOutlined />} size="small"
                                onClick={() => { deleteTime(index) }}
                            />
                        </Col>
                    </Row>
                </Col>
            )))
        } else {
            return "";
        }
    }

    const save = () => {
        var localDataString = localStorage.getItem('appLimits');
        var localData = localDataString ? JSON.parse(localDataString) : [];
        addTemplateClick(localData);
    }

    const updateAppLimit = () => {
        var res: any = {};
        res.categories = selectType;
        res.executionRules = [];
        res.IsCustomized = selectKey == "custom"
        res.id = selectId ? selectId : uuidv4();
        var i = 0;
        for (i; i < dayList.length; i++) {
            var item = dayList[i];
            if (!res.IsCustomized && item.worshipDay != 0) {
                continue;
            }
            if (item.times.length > 0) {
                var durations: any[] = [];
                item.times.forEach((time: any) => {
                    durations.push({
                        startTime: time[0].format('HH:mm'),
                        endTime: time[1].format('HH:mm')
                    })
                });
                res.executionRules.push({
                    worshipDay: item.worshipDay,
                    durations: durations
                })
            }
        }
        
        if (res.categories.length > 0 && res.executionRules.length > 0) {
            var localDataString = localStorage.getItem('appLimits');
            var localData = localDataString ? JSON.parse(localDataString) : [];
            var isReplace = false;
            if (localData.length >= resData.length) {
                var totalData: any = localData;
            } else {
                var totalData: any = [...resData, ...localData]
            }
            if (totalData.length > 0) {
                totalData = totalData.map((data: any) => { 
                    if (data.id === res.id) {
                        data = res;
                        isReplace = true;
                    }
                    return data;
                 });
            }
            if (!isReplace) {
                totalData.push(res);
            }
            localStorage.setItem('appLimits', JSON.stringify(totalData));
            getDataInfo(totalData);
            setLoading(false);
            setShowModal(false);
        } else {
            notification.warning({message: t("所有字段不能为空")});
            getDataInfo();
            setLoading(false);
            setShowModal(false);
        }
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px"}} >
                <Col className="templateTitle">{t("应用限制规则")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin:"32px 16px 8px 50px", fontSize: "14px" }}>{t("设置应用限制规则")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentPassword", "onClick", "addClick") }} type="primary">
                            <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {(showTable == 2 && tags.length != 0) && (
                    <>
                        <div className="tAr">
                            <Button type="primary" onClick={() => {
                                setShowModal(true);
                                setSelectId("");
                                setDayList([]);
                                setSelectType([]);
                                gaEvent("templateContentWebClip", "onClick", "添加WebClip")
                            }}><PlusOutlined />{t("添加限制")}</Button>
                        </div>
                        <Table

                            size="middle"
                            loading={tableLoading}
                            dataSource={resData}
                            pagination={false}
                            style={{ width: "100%",marginLeft:8 }}
                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        >
                            <Column

                                key="categories"
                                dataIndex="categories"
                                title={t("限制应用类别")}
                                render={(v, d, i) => (
                                    <>
                                        {v.map((item: any, index: number) => (
                                            <Tag key={index}>{getAppName(item)}</Tag>
                                        ))}
                                    </>
                                )}
                            ></Column>
                            <Column
                                key="executionRules"
                                dataIndex="executionRules"
                                title={t("限制使用时间")}
                                render={(v, d: any, i) => (
                                    <>
                                        {getTimeShow(v, d.isCustomized)}
                                    </>
                                )}
                            ></Column>
                            <Column
                                key="id"
                                dataIndex="id"
                                title={t("操作")}
                                render={(v, d, i) => (
                                    <>
                                        <Button type="link" onClick={() => { setModelInfo(d) }}>{t("编辑")}</Button>
                                        <Button type="text" onClick={() => { deleteAppRestrictionAloneClick(v) }} danger>{t("删除")}</Button>
                                    </>
                                )}
                            ></Column>
                        </Table>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { save() }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentPassword", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
            <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={showModal}
                title={`${isEdit ? t('编辑应用限制') : t('添加应用限制')}`}
                width={"1000px"}
                onOk={() => {
                    updateAppLimit()
                    // addTemplateClick();
                    // gaEvent("templateContentPassword", "onClick", "addTemplateClick");
                }}
                onCancel={() => { 
                    setShowModal(false);
                    setIsEdit(false);
                }}
                okText={t("确认")}
                cancelText={t("取消")}
            >
                <>
                    <Row style={{ width: "100%", margin: 10 }}>
                        <Col span={4} style={{ textAlign: "center" }}>{t("应用类别")}:</Col>
                        <Col span={20}>
                            {appTypes.length != 0 && (
                                <Select
                                    value={selectType}
                                    mode="multiple"
                                    allowClear
                                    style={{ width: '100%' }}
                                    placeholder={t("请选择类别")}
                                    onChange={appTypeChange}
                                    filterOption={(input, option: any) => {
                                        return stringContaint(input, option.children);

                                    }}
                                >
                                    {appTypes?.map((itm: any, index) => (
                                        <Select.Option key={itm.id} value={itm.id} >{itm.chineseName}</Select.Option>
                                    ))}
                                </Select>

                            )}

                        </Col>
                    </Row>

                    <Row style={{ width: "100%", margin: 10 }}>
                        <Col span={4} style={{ textAlign: "center" }}>{t("模式")}:</Col>
                        <Col span={12}>
                            <Radio.Group buttonStyle="solid" value={selectKey} onChange={(e) => {
                                if (e.target.value == "everyDay") {
                                    setSelectWeek(0);
                                }
                                selectTypeChange(e.target.value);
                            }} >
                                <Radio.Button value="custom" >{t("自定义")}</Radio.Button>
                                <Radio.Button value="everyDay">{t("每天")}</Radio.Button>
                            </Radio.Group>
                        </Col>
                        {/* <Col span={4} style={{ color: "gray" }}><InfoCircleOutlined />&nbsp;&nbsp;&nbsp;拦截的链接无法访问</Col> */}
                    </Row>
                    {selectKey == "custom" && (
                        <Row style={{ width: "100%", margin: 10 }}>
                            <Col span={4} style={{ textAlign: "center" }}>{t("星期")}:</Col>
                            <Col span={18}>

                                <Radio.Group buttonStyle="solid" value={selectWeek} onChange={(e) => { setSelectWeek(e.target.value) }} >
                                    <Radio.Button value={0}>{t("星期天")}</Radio.Button>
                                    <Radio.Button value={1}>{t("星期一")}</Radio.Button>
                                    <Radio.Button value={2}>{t("星期二")}</Radio.Button>
                                    <Radio.Button value={3}>{t("星期三")}</Radio.Button>
                                    <Radio.Button value={4}>{t("星期四")}</Radio.Button>
                                    <Radio.Button value={5}>{t("星期五")}</Radio.Button>
                                    <Radio.Button value={6}>{t("星期六")}</Radio.Button>

                                </Radio.Group>
                            </Col>
                        </Row>

                    )}

                    <Row style={{ width: "100%", marginLeft: 16 }}>
                        <Col span={4} style={{ textAlign: "center" }}>{t("时间")}:</Col>
                        <Col span={18}>
                            <Row gutter={[16, 16]}>
                                {getWeedTimeShow()}

                            </Row>
                            <Row style={{ marginTop: 16 }}>
                                <Button type="dashed" onClick={() => { addTimeClick() }} block>
                                    {t("添加时间")}
                                </Button>
                            </Row>



                        </Col>

                    </Row>
                </>
            </Modal>

        </div>
    </>);
};